import React from "react";
import { FormSectionElements } from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";

type Props = {
    isEng: boolean;
    field: FormSectionElements;
}

const SubsectionTextDisplayComponent = ({isEng, field}: Props) => {
    
    FormValidationUtils.runJavascript(field);
    if (field.Visible == false) return null;
    return(
        <div>
            <h5>{isEng ? field.ENUTitle : field.FRATitle}</h5>
            <p>{isEng ? field.Value : field.ValueFRA}</p>
        </div>
    );
}

export default SubsectionTextDisplayComponent;